'use client';

import {useForwardingRef} from '@rocket-ui/react-tools';
import cn from 'classnames';
import React, {useEffect} from 'react';

export type NewTextAreaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const NewTextArea = React.forwardRef<HTMLTextAreaElement, NewTextAreaProps>(
	({value, className, ...props}, ref) => {
		const textareaRef = useForwardingRef(ref);

		useEffect(() => {
			if (!textareaRef.current) return;

			textareaRef.current.style.height = '0px';
			const height = textareaRef.current.scrollHeight;
			textareaRef.current.style.height = `${height}px`;
		}, [value]);

		return (
			<textarea
				value={value}
				className={cn(
					'w-full p-0 bg-transparent overflow-hidden resize-none border-none text-sm tracking-tight placeholder-black/30',
					className,
				)}
				role={'textbox'}
				{...props}
				ref={textareaRef}
			/>
		);
	},
);
